import * as Yup from 'yup'

/*
  As duas escritas que um admin tem sobre um recebível: cancelar e resolver.

  O mesmo formulário serve aos dois porque o que muda é só o `outcome` — mas eles respondem a
  perguntas diferentes, e é por isso que a API os separa em rotas distintas. Cancelar diz
  "esta obrigação não deveria existir" (atendimento validado por engano, fraude). Resolver diz
  "esta obrigação teve um desfecho que a máquina não conseguiu observar", e é a saída dos
  repasses que travaram sem resposta do Asaas.
*/

/*
  O mesmo mínimo de `AdminPayoutsController.MIN_REASON_LENGTH`. Motivo mais curto que isto não
  é motivo — é alguém apertando enter para passar da tela —, e estes registros são o que
  responde "por que este repasse não saiu?" meses depois.
*/
export const MIN_REASON_LENGTH = 10

const payoutResolutionValidator = Yup.object ().shape ({
  /*
    `paid` quer dizer "a transferência está no extrato da conta Cutilei no Asaas"; `canceled`,
    "não está". Só é exigido na resolução; no cancelamento o campo nem aparece.
  */
  resolving: Yup.boolean (),

  outcome: Yup.string ()
    .when ('resolving', {
      is: true,
      then: schema => schema
        .required ('Informe se a transferência saiu')
        .oneOf (['paid', 'canceled'], 'Informe se a transferência saiu')
    }),

  reason: Yup.string ()
    .trim ()
    .required ('Descreva o motivo')
    .min (MIN_REASON_LENGTH, `Descreva com pelo menos ${MIN_REASON_LENGTH} caracteres`)
})

export default payoutResolutionValidator
